import React from 'react';
import Link from "../../../components/pages/grid/Link/Link";

const LinkGridPage = () => {
    return <Link />
};

export default LinkGridPage;
